import { User } from "@domains/user";
import { ClaimDto } from "../dtos/response/claim.dto";

export function mapClaimsDtoToUser(claims: ClaimDto[]): User {
	const id = claims.find((x) => x.type === "sub");
	const firstName = claims.find((x) => x.type === "given_name");
	const lastName = claims.find((x) => x.type === "family_name");
	const email = claims.find((x) => x.type === "email");
	const logoutUrl = claims.find((x) => x.type === "bff:logout_url");

	if (id === undefined || logoutUrl === undefined) {
		throw new Error("Error parsing User model from Response");
	}

	return new User(id.value, firstName?.value ?? "", lastName?.value ?? "", email?.value ?? "", logoutUrl.value);
}
